export default {
  LEFT: 'left',
  RIGHT: 'right'
}
